// removed by extract-text-webpack-plugin
module.exports = {"billing-reminder":"app-components-BillingReminder-__BillingReminder___1MJr7","notification-expire":"app-components-BillingReminder-__BillingReminder___1FIUH","text-notif":"app-components-BillingReminder-__BillingReminder___1UYVa","disable-link":"app-components-BillingReminder-__BillingReminder___2GNlE"};


//////////////////
// WEBPACK FOOTER
// ./app/components/BillingReminder/BillingReminder.css
// module id = 2158
// module chunks = 0